import React, { Component } from "react";
import axios from "axios";
import { PiCertificateThin } from "react-icons/pi";
import { FaAppStore } from "react-icons/fa";
import { AiOutlineDatabase } from "react-icons/ai";
import { CiPen } from "react-icons/ci";
import { GiBlackBook } from "react-icons/gi";
import { LuNotebook } from "react-icons/lu";
import { MdOutlineVerifiedUser } from "react-icons/md";
import { GiField } from "react-icons/gi";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { MdOutlineVerified } from "react-icons/md";

class IncludeCourse extends Component {
    state = {
        course: [],
        checkedOptions: new Set(),
    };

    getIconForOption = (option) => {
        switch (option) {
            case 'Software':
                return <FaAppStore />;
            case 'Data':
                return <AiOutlineDatabase />;
            case 'Biro':
                return <CiPen />;
            case 'Jotter':
                return <LuNotebook />;
            case 'Manual':
                return <GiBlackBook />;
            case '100% Practical':
                return <MdOutlineVerifiedUser />;
            case 'Field Experience':
                return <GiField />;
            case 'Free Consultation':
                return <MdOutlinePhoneInTalk />;
            case 'Exam and Certificate':
                return <PiCertificateThin />;
            case 'Free internship':
                return <MdOutlineVerified />;
            case 'Access job opportunities':
                return <MdOutlineVerified />;
            default:
                return null;
        }
    };

    componentDidMount() {
        this.fetchCourses();
    }
    componentDidUpdate(prevProps) {
        if (this.props.course_id !== prevProps.course_id) {
            this.fetchCourses();
        }
    }
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const course_id = this.props.course_id;
            const courseId = parseInt(course_id, 10);
            const response = await axios.get(`https://api.geoinfoacademy.com/api/tutor/courses/${courseId}`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            const courseData = response.data;
            this.setState({ course: courseData });

            // Initialize checkedOptions based on API data
            if (courseData && courseData.package) {
                const initialChecked = new Set(courseData.package); // Directly use the array of strings
                this.setState({ checkedOptions: initialChecked });
            }

            console.log("API Response:", courseData);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    handleInputChange = async (event) => {
        const option = event.target.value;
        const isChecked = event.target.checked;

        const updatedCheckedOptions = new Set(this.state.checkedOptions);

        if (isChecked) {
            updatedCheckedOptions.add(option);
        } else {
            updatedCheckedOptions.delete(option);
        }

        this.setState({ checkedOptions: updatedCheckedOptions });

        try {
            await this.updateCoursePackage(Array.from(updatedCheckedOptions)); // Update API immediately with array of strings
            console.log("Course package updated successfully");
        } catch (error) {
            console.error("Error updating course package:", error);
            // Important: Revert the checkbox change in the UI if the API update fails
            if (isChecked) {
                updatedCheckedOptions.delete(option);
            } else {
                updatedCheckedOptions.add(option);
            }
            this.setState({ checkedOptions: updatedCheckedOptions }); // Reset to previous state
            alert("Error updating course package. Please try again."); // Or a better error message
        }
    };

    updateCoursePackage = async (packageData) => {
        const accessToken = localStorage.getItem("accessToken");
        const courseId = parseInt(this.props.course_id, 10);

        try {
            await axios.patch(
                `https://api.geoinfoacademy.com/api/tutor/courses/${courseId}/`,
                { package: packageData }, // Use the passed packageData
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            this.fetchCourses();
        } catch (error) {
            throw error; // Re-throw the error to be caught by handleInputChange
        }
    };

    render() {
        const coursecontent = this.state.course;
        const { checkedOptions } = this.state;

        const include = coursecontent && coursecontent.package && coursecontent.package.length ? (
            coursecontent.package.map((packageItem) => (
                <li className="body" key={packageItem}>
                    {this.getIconForOption(packageItem)}
                    {packageItem}
                </li>
            ))
        ) : (<p>Loading...</p>);

        const allOptions = [
            "Software", "Data", "Biro", "Jotter", "Manual", "100% Practical",
            "Field Experience", "Free Consultation", "Exam and Certificate",
            "Free internship", "Access job opportunities"
        ];

        return (
            <section className="descript_include">
                <li className="head">WHAT’S INCLUDED</li>
                {include}

                <div className="checkbox-options" >
                    {allOptions.map(option => (
                        <div key={option} style={{ display: "inline-block" }}>
                            <input
                                type="checkbox"
                                id={option.toLowerCase().replace(/\s+/g, '')}
                                name={option.toLowerCase().replace(/\s+/g, '')}
                                value={option}
                                className="check"
                                checked={checkedOptions.has(option)}
                                onChange={this.handleInputChange}
                            />
                            <label htmlFor={option.toLowerCase().replace(/\s+/g, '')} className="check">{option}</label>
                        </div>
                    ))}
                </div>
            </section>
        );
    }
}

export default IncludeCourse;